import React from 'react';
function Chip(params) {
    return (React.createElement("div", { className: "qmb-chip", style: { display: 'flex', gap: '.5rem', alignItems: 'center' } },
        React.createElement("span", null, params.icon),
        React.createElement("span", null, params.label)));
}
export default Chip;
